import styled from 'styled-components';

export const ContainerCheckout = styled.div`
  width: 100vw;
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  font-family: 'Libre Franklin', sans-serif;
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: none;
  width: 100vw;
  align-items: center;
`;

export const TitleForm = styled.div`
  display: flex;
  flex-direction: column;
  flex: none;
  width: 89.333vw;
  font-family: 'Libre Franklin', sans-serif;
  align-items: flex-start;

  p {
    font-size: 5.866vw;
    font-weight: 700;
    margin: 5.093vw 0 1.6vw 0;
  }
  span {
    font-size: 3.733vw;
    font-weight: 400;
    margin: 0 0 5.333vw 0;
    width: 82.133vw;
  }
`;

export const CheckoutComponent = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 89.333vw;
  margin-bottom: 5vw;
  align-items: center;
`;
